import { render } from "./AddProducts.vue?vue&type=template&id=287f5bb0"
import script from "./AddProducts.vue?vue&type=script&lang=js"
export * from "./AddProducts.vue?vue&type=script&lang=js"

import "./AddProducts.vue?vue&type=style&index=0&id=287f5bb0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__